export class FileSystem {
    id: number = -1;
    folderName: string = '';
    description: string = '';
    parentId: number = -1;
    createdBy: number = -1;
    createdAt: string = '';
    updatedAt: string = '';
}
